module.exports = __webpack_public_path__ + "img/fixed-2.0ba5d8f4.png";